import { useState } from 'react';
import api from '../../api';

const CORE_TRIGGERS = [
  { v: 'after_mould_close',  l: 'After mould close' },
  { v: 'after_injection',    l: 'After injection' },
  { v: 'after_cooling',      l: 'After cooling' },
  { v: 'after_mould_open',   l: 'After mould open' },
  { v: 'after_ejection_fwd', l: 'After ejection fwd' },
  { v: 'after_ejection_ret', l: 'After ejection return' },
];

const MAT_FAMILIES = ['PP', 'PE', 'ABS', 'PC', 'PA6', 'PA66', 'POM', 'PET', 'PVC', 'TPE', 'TPU', 'PS', 'PMMA'];

const STEEL_GRADES = [
  { v: '1.2343', l: '1.2343 / X38CrMoV5-1 / UTOP MO1' },
  { v: '1.2344', l: '1.2344 / X40CrMoV5-1 / UTOP MO2' },
  { v: '1.2312', l: '1.2312 / 40CrMnMoS8-6 / UTOP N' },
  { v: 'AMPCO®', l: 'AMPCO®' },
  { v: 'FCMO',   l: 'FCMO' },
  { v: 'OCR',    l: 'OCR' },
  { v: 'P20',    l: 'P20' },
  { v: 'H13',    l: 'H13' },
  { v: 'S136',   l: 'S136' },
  { v: 'aluminium', l: 'Aluminium' },
  { v: 'other',  l: 'Other…' },
];

const EJ_TYPES = [
  { v: '',               l: '— select —' },
  { v: 'pin',            l: 'Pin' },
  { v: 'blade',          l: 'Blade' },
  { v: 'stripper-plate', l: 'Stripper plate' },
  { v: 'sleeve',         l: 'Sleeve' },
  { v: 'air',            l: 'Air ejection' },
  { v: 'other',          l: 'Other' },
];

const EJ_COUPLES = [
  { v: '',           l: '— select —' },
  { v: 'none',       l: 'None (free)' },
  { v: 'mechanical', l: 'Mechanical' },
  { v: 'hydraulic',  l: 'Hydraulic return' },
  { v: 'other',      l: 'Other' },
];

const MOULD_BASES = [
  { v: '',            l: '— select —' },
  { v: 'HASCO',       l: 'HASCO' },
  { v: 'DME',         l: 'DME' },
  { v: 'Meusburger',  l: 'Meusburger' },
  { v: 'LKM',         l: 'LKM' },
  { v: 'other',       l: 'Other…' },
];

export default function MouldForm({ mould, onSaved, onCancel, compact = false, isDirector = false }) {
  const isNew = !mould;

  const [form, setForm] = useState({
    ref:               mould?.ref               || '',
    name:              mould?.name              || '',
    customer:          mould?.customer          || '',
    part_no:           mould?.part_no           || '',
    status:                mould?.status                || 'active',
    maintenance_until:     mould?.maintenance_until      || '',
    maintenance_indefinite:mould?.maintenance_indefinite || false,
    mat_families:      mould?.mat_families      || [],
    cavities:          mould?.cavities          || '',
    weight_kg:         mould?.weight_kg         || '',
    stack_mm:          mould?.stack_mm          || '',
    mould_width_mm:    mould?.mould_width_mm    || '',
    mould_length_mm:   mould?.mould_length_mm   || '',
    min_open_mm:       mould?.min_open_mm       || '',
    pa_cm2:            mould?.pa_cm2            || '',
    wmax_mm:           mould?.wmax_mm           || '',
    wmin_mm:           mould?.wmin_mm           || '',
    mould_base:        mould?.mould_base        || '',
    mould_base_custom: mould?.mould_base === 'other' ? (mould?.mould_base_custom || '') : '',
    gate_type:         mould?.gate_type         || 'edge',
    gw_mm:             mould?.gw_mm             || '',
    gd_mm:             mould?.gd_mm             || '',
    gdia_mm:           mould?.gdia_mm           || '',
    gate_count:        mould?.gate_count        || '',
    runner:            mould?.runner            || 'cold',
    runner_layout:     mould?.runner_layout     || '',
    circuits:          mould?.circuits          || '',
    water_dia_mm:      mould?.water_dia_mm      || '',
    target_mould_temp: mould?.target_mould_temp ?? '',
    cooling_medium:    mould?.cooling_medium    || '',
    cooling_layout:    mould?.cooling_layout    || '',
    cooling_type:      mould?.cooling_type      || '',
    ej_type:           mould?.ej_type           || '',
    ej_count:          mould?.ej_count          || '',
    ej_stroke_mm:      mould?.ej_stroke_mm      || '',
    ej_pulses:         mould?.ej_pulses         || '',
    ej_couple:         mould?.ej_couple         || '',
    ej_side:           mould?.ej_side           || '',
    side_actions:      mould?.side_actions      || false,
    lifters:           mould?.lifters           || false,
    sw_g:              mould?.sw_g              || '',
    pw_g:              mould?.pw_g              || '',
    rw_g:              mould?.rw_g              || '',
    surface_treatment: mould?.surface_treatment || '',
    insp_int:          mould?.insp_int          || '',
    refurb_int:        mould?.refurb_int        || '',
    toolchange_mount_min:   mould?.toolchange_mount_min   ?? '',
    toolchange_unmount_min: mould?.toolchange_unmount_min ?? '',
    additional_startup_min: mould?.additional_startup_min ?? '',
    toolmaker:         mould?.toolmaker         || '',
    mould_notes:       mould?.mould_notes       || '',
    notes:             mould?.notes             || '',
    parting_line:      mould?.parting_line      || '',
    vent_depth_mm:     mould?.vent_depth_mm     || '',
    vent_notes:        mould?.vent_notes        || '',
    in_mould_label:    mould?.in_mould_label    || false,
    insert_moulding:   mould?.insert_moulding   || false,
    insert_type:       mould?.insert_type       || '',
    mould_breathing:   mould?.mould_breathing   || false,
    mould_breathing_mm:mould?.mould_breathing_mm|| '',
    tool_cost:         mould?.tool_cost         || '',
    shot_life:         mould?.shot_life         || '',
    shot_limit_kind:   mould?.shot_limit_kind   || 'warranty',
    // Shown only once a count was entered: an empty field, not a 0 that reads
    // as "no shots", while the app counts the tool's production itself.
    shots:             mould?.shots_counted_on || Number(mould?.shots) > 0 ? mould.shots : '',
    shots_counted_on:  mould?.shots_counted_on  || '',
    service_every_shots: mould?.service_every_shots || '',
    service_every_n:     mould?.service_every_n     || '',
    service_every_unit:  mould?.service_every_unit  || '',
  });

  const [steelGrades, setSteelGrades] = useState(mould?.steel_grades || []);
  const [customMatInput, setCustomMatInput] = useState('');

  const initHr   = mould?.hot_runner_data    || {};
  const initSpec = mould?.special_mechanisms || {};

  const [hrData, setHrData] = useState({
    nozzle_type:   initHr.nozzle_type   || 'open',
    controller:    initHr.controller    || '',
    manifold_temp: initHr.manifold_temp ?? '',
    zones:         initHr.zones         || [],
  });

  const [specMech, setSpecMech] = useState({
    pneumatic_ejector:       initSpec.pneumatic_ejector       || false,
    pneumatic_ejector_notes: initSpec.pneumatic_ejector_notes || '',
    collapsible_cores:       initSpec.collapsible_cores       || false,
    collapsible_cores_notes: initSpec.collapsible_cores_notes || '',
    unscrewing:              initSpec.unscrewing              || false,
    unscrewing_notes:        initSpec.unscrewing_notes        || '',
  });

  const [cores, setCores]               = useState(mould?.cores          || []);
  const [coolingZones, setCoolingZones] = useState(mould?.cooling_zones  || []);
  const [customFields, setCustomFields] = useState(mould?.custom_fields  || []);
  const [saving, setSaving]             = useState(false);
  const [error, setError]               = useState('');

  function set(key, value)     { setForm(f => ({ ...f, [key]: value })); }
  function setHr(key, value)   { setHrData(d => ({ ...d, [key]: value })); }
  function setSpec(key, value) { setSpecMech(m => ({ ...m, [key]: value })); }

  function setHrZone(i, key, value) {
    setHrData(d => ({ ...d, zones: d.zones.map((z, idx) => idx === i ? { ...z, [key]: value } : z) }));
  }
  function addHrZone()     { setHrData(d => ({ ...d, zones: [...d.zones, { label: '', temp: '' }] })); }
  function removeHrZone(i) { setHrData(d => ({ ...d, zones: d.zones.filter((_, idx) => idx !== i) })); }

  function addZone()              { setCoolingZones(z => [...z, { location: 'injection-half', diameter_mm: '', length_mm: '', circuits: '' }]); }
  function removeZone(i)          { setCoolingZones(z => z.filter((_, idx) => idx !== i)); }
  function setZone(i, key, value) { setCoolingZones(z => z.map((zone, idx) => idx === i ? { ...zone, [key]: value } : zone)); }

  function addCore() {
    setCores(c => [...c, { name: '', actuator_type: 'hydraulic', pressure_bar: '', speed_mm_s: '', stroke_mm: '', actuating_time_s: '', waiting_times: [] }]);
  }
  function removeCore(i)          { setCores(c => c.filter((_, idx) => idx !== i)); }
  function setCore(i, key, value) { setCores(c => c.map((core, idx) => idx === i ? { ...core, [key]: value } : core)); }

  function addWait(i) {
    setCores(c => c.map((core, idx) => idx !== i ? core : {
      ...core, waiting_times: [...(core.waiting_times || []), { trigger: 'after_mould_close', time_s: '' }],
    }));
  }
  function removeWait(ci, wi) {
    setCores(c => c.map((core, idx) => idx !== ci ? core : {
      ...core, waiting_times: (core.waiting_times || []).filter((_, wIdx) => wIdx !== wi),
    }));
  }
  function setWait(ci, wi, key, value) {
    setCores(c => c.map((core, idx) => idx !== ci ? core : {
      ...core, waiting_times: (core.waiting_times || []).map((wt, wIdx) => wIdx !== wi ? wt : { ...wt, [key]: value }),
    }));
  }

  function addCustomField()              { setCustomFields(f => [...f, { label: '', value: '' }]); }
  function removeCustomField(i)          { setCustomFields(f => f.filter((_, idx) => idx !== i)); }
  function setCustomField(i, key, value) { setCustomFields(f => f.map((cf, idx) => idx === i ? { ...cf, [key]: value } : cf)); }

  // mat_families helpers
  function toggleMat(mat) {
    const cur = form.mat_families;
    set('mat_families', cur.includes(mat) ? cur.filter(m => m !== mat) : [...cur, mat]);
  }
  function addCustomMat() {
    const name = customMatInput.trim();
    if (name && !form.mat_families.includes(name)) {
      set('mat_families', [...form.mat_families, name]);
    }
    setCustomMatInput('');
  }
  function removeMat(mat) {
    set('mat_families', form.mat_families.filter(m => m !== mat));
  }

  // steel grades helpers
  function addSteelGrade() {
    setSteelGrades(g => [...g, { description: '', grade: '1.2343', custom: '' }]);
  }
  function removeSteelGrade(i) {
    setSteelGrades(g => g.filter((_, idx) => idx !== i));
  }
  function setSteelGrade(i, k, v) {
    setSteelGrades(g => g.map((item, idx) => idx === i ? { ...item, [k]: v } : item));
  }

  function save() {
    if (!form.ref)  { setError('Mould reference is required'); return; }
    if (!form.name) { setError('Mould name is required'); return; }
    if ((form.service_every_n !== '') !== (form.service_every_unit !== '')) {
      setError('A service interval in time needs both the number and weeks or months — or neither.'); return;
    }
    setSaving(true);
    const payload = { ...form };
    ['cavities','weight_kg','stack_mm','mould_width_mm','mould_length_mm','min_open_mm','pa_cm2','wmax_mm','wmin_mm',
     'gw_mm','gd_mm','gdia_mm','gate_count','circuits','water_dia_mm','target_mould_temp',
     'ej_count','ej_stroke_mm','ej_pulses','sw_g','pw_g','rw_g','insp_int','refurb_int',
     'toolchange_mount_min','toolchange_unmount_min','additional_startup_min',
     'vent_depth_mm','mould_breathing_mm',
     'tool_cost','shot_life','shots','service_every_shots','service_every_n',
    ].forEach(k => { payload[k] = payload[k] !== '' ? parseFloat(payload[k]) : null; });
    if (payload.service_every_unit === '') payload.service_every_unit = null;
    if (payload.shots_counted_on === '') payload.shots_counted_on = null;
    // An empty count field (nothing entered yet) keeps what is stored, so a
    // save does not write "shot count 0 to empty" into the history.
    if (payload.shots == null && !payload.shots_counted_on) payload.shots = mould?.shots ?? null;

    if (payload.maintenance_until === '') payload.maintenance_until = null;
    payload.hot_runner = form.runner === 'hot';
    payload.hot_runner_data = form.runner === 'hot' ? {
      ...hrData,
      manifold_temp: hrData.manifold_temp !== '' ? parseFloat(hrData.manifold_temp) : null,
      zones: hrData.zones.map(z => ({ ...z, temp: z.temp !== '' ? parseFloat(z.temp) : null })),
    } : null;

    payload.cores = cores.map(c => ({
      ...c,
      pressure_bar:     c.pressure_bar     !== '' ? parseFloat(c.pressure_bar)     : null,
      speed_mm_s:       c.speed_mm_s       !== '' ? parseFloat(c.speed_mm_s)       : null,
      stroke_mm:        c.stroke_mm        !== '' ? parseFloat(c.stroke_mm)        : null,
      actuating_time_s: c.actuating_time_s !== '' ? parseFloat(c.actuating_time_s) : null,
      waiting_times: (c.waiting_times || []).map(wt => ({
        ...wt, time_s: wt.time_s !== '' ? parseFloat(wt.time_s) : null,
      })),
    }));

    payload.cooling_zones = coolingZones.map(z => ({
      ...z,
      diameter_mm: z.diameter_mm !== '' ? parseFloat(z.diameter_mm) : null,
      length_mm:   z.length_mm   !== '' ? parseFloat(z.length_mm)   : null,
      circuits:    z.circuits    !== '' ? parseFloat(z.circuits)     : null,
    }));

    payload.special_mechanisms = specMech;
    payload.custom_fields      = customFields;
    payload.steel_grades       = steelGrades;

    const req = isNew
      ? api.post('/api/v1/moulds', payload)
      : api.put(`/api/v1/moulds/${mould.id}`, payload);

    req.then(r => onSaved(r.data)).catch(err => {
      setError(err.response?.data?.error || 'Save failed');
      setSaving(false);
    });
  }

  const circularGate = ['pin','valve','submarine'].includes(form.gate_type);

  return (
    <div>
      {error && <div style={s.error}>{error}</div>}

      <div style={compact ? s.compactGrid : s.fullGrid}>

        {/* ── Identity ── */}
        <Section title="Identity">
          <Field label="Mould ref *" value={form.ref} onChange={v => set('ref', v)}
            info="Unique identifier code for this mould — used across all production records" />
          <Field label="Mould name *" value={form.name} onChange={v => set('name', v)}
            info="Descriptive name for the mould, e.g. product name or customer part name" />
          <Field label="Customer" value={form.customer} onChange={v => set('customer', v)}
            info="Who this mould was made for, or who owns the part it produces" />
          <Field label="Part number" value={form.part_no} onChange={v => set('part_no', v)}
            info="Customer or internal part number this mould produces" />
          <Select label="Status" value={form.status} onChange={v => set('status', v)}
            options={[{v:'active',l:'Active'},{v:'maintenance',l:'Maintenance'},{v:'repair',l:'In repair'},{v:'archived',l:'Archived'}]}
            info="Current operational status — archived moulds are hidden from active selection" />
          {form.status === 'maintenance' && (
            <div style={{ background: '#1a1f2e', border: '1px solid #92400e', borderRadius: '8px', padding: '12px', marginTop: '4px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#f59e0b', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Maintenance duration</div>
              <Check label="Indefinite (until manually changed)" checked={form.maintenance_indefinite} onChange={v => set('maintenance_indefinite', v)} />
              {!form.maintenance_indefinite && (
                <Field label="Expected back (date)" value={form.maintenance_until} onChange={v => set('maintenance_until', v)} type="date" />
              )}
            </div>
          )}

          {/* Material families — multi-select */}
          <div style={s.field}>
            <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: '4px' }}>
              Material families
              <Info text="Which plastic material families this mould is designed to process" />
            </label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '6px' }}>
              {MAT_FAMILIES.map(mat => (
                <button key={mat} type="button" onClick={() => toggleMat(mat)}
                  style={{
                    padding: '4px 10px', fontSize: '11px', fontWeight: '600', borderRadius: '4px', cursor: 'pointer',
                    background: form.mat_families.includes(mat) ? '#14b8a6' : '#0f1117',
                    color: form.mat_families.includes(mat) ? '#fff' : '#9ca3af',
                    border: `1px solid ${form.mat_families.includes(mat) ? '#14b8a6' : '#2a3040'}`,
                    fontFamily: 'system-ui, sans-serif',
                  }}>
                  {mat}
                </button>
              ))}
            </div>
            {/* custom material entries that aren't standard chips */}
            {form.mat_families.filter(m => !MAT_FAMILIES.includes(m)).map(m => (
              <div key={m} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', background: '#14b8a6', color: '#fff', borderRadius: '4px', padding: '3px 8px', fontSize: '11px', fontWeight: '600', marginRight: '5px', marginBottom: '4px' }}>
                {m}
                <button type="button" onClick={() => removeMat(m)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: 0, fontSize: '12px', lineHeight: 1 }}>×</button>
              </div>
            ))}
            <div style={{ display: 'flex', gap: '6px', marginTop: '4px' }}>
              <input
                style={{ ...s.input, flex: 1 }}
                placeholder="Other material…"
                value={customMatInput}
                onChange={e => setCustomMatInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addCustomMat())}
              />
              <button type="button" style={s.addSmallBtn} onClick={addCustomMat}>Add</button>
            </div>
          </div>
        </Section>

        {/* ── Geometry ── */}
        <Section title="Geometry">
          <Field label="Cavities" value={form.cavities} onChange={v => set('cavities', v)} type="number"
            info="How many identical parts this mould produces per injection cycle" />
          <Field label="Projected area (cm²)" value={form.pa_cm2} onChange={v => set('pa_cm2', v)} type="number"
            info="Total cavity footprint projected onto the parting plane — used to calculate minimum clamping force needed" />
          <Field label="Wall max (mm)" value={form.wmax_mm} onChange={v => set('wmax_mm', v)} type="number"
            info="Thickest wall section in the part — affects fill pressure and cooling time" />
          <Field label="Wall min (mm)" value={form.wmin_mm} onChange={v => set('wmin_mm', v)} type="number"
            info="Thinnest wall section — affects minimum injection speed and fill risk" />
          <Field label="Stack height (mm)" value={form.stack_mm} onChange={v => set('stack_mm', v)} type="number"
            info="Closed mould height from platen face to platen face — must fit within machine daylight" />
          <Field label="Mould width (mm)" value={form.mould_width_mm} onChange={v => set('mould_width_mm', v)} type="number"
            info="Mould width footprint — must fit between machine tie bars" />
          <Field label="Mould length (mm)" value={form.mould_length_mm} onChange={v => set('mould_length_mm', v)} type="number"
            info="Mould length footprint — must fit between machine tie bars" />
          <Field label="Min opening (mm)" value={form.min_open_mm} onChange={v => set('min_open_mm', v)} type="number"
            info="Minimum daylight the machine must open so the part can be fully extracted" />
          <Field label="Mould weight (kg)" value={form.weight_kg} onChange={v => set('weight_kg', v)} type="number"
            info="Total mould weight — determines crane requirement and machine platen load rating" />
        </Section>

        {/* ── Gating ── */}
        <Section title="Gating">
          <Select label="Gate type" value={form.gate_type} onChange={v => set('gate_type', v)}
            options={[{v:'edge',l:'Edge'},{v:'submarine',l:'Submarine'},{v:'pin',l:'Pin'},{v:'valve',l:'Valve'},{v:'direct',l:'Direct'}]}
            info="How molten plastic enters the cavity — determines vestige, gate mark location, and processing window" />
          {!circularGate && <>
            <Field label="Gate width (mm)" value={form.gw_mm} onChange={v => set('gw_mm', v)} type="number"
              info="Width of the gate channel cross-section" />
            <Field label="Gate depth (mm)" value={form.gd_mm} onChange={v => set('gd_mm', v)} type="number"
              info="Depth (height) of the gate channel cross-section" />
          </>}
          {circularGate && (
            <Field label="Gate diameter (mm)" value={form.gdia_mm} onChange={v => set('gdia_mm', v)} type="number"
              info="Diameter of the gate opening for circular gate types" />
          )}
          <Field label="Gate count" value={form.gate_count} onChange={v => set('gate_count', v)} type="number"
            info="Number of injection points per cavity" />
          <Select label="Runner" value={form.runner} onChange={v => set('runner', v)}
            options={[{v:'cold',l:'Cold runner'},{v:'hot',l:'Hot runner'},{v:'insulated',l:'Insulated runner'}]}
            info="How material is delivered to the gates — cold runners create sprue waste; hot runners eliminate it" />
          <Select label="Runner layout" value={form.runner_layout} onChange={v => set('runner_layout', v)}
            options={[{v:'',l:'— select —'},{v:'naturally-balanced',l:'Naturally balanced'},{v:'artificially-balanced',l:'Artificially balanced'}]}
            info="Whether runner branches are equal length (naturally balanced) or need flow restrictors (artificially balanced) to fill evenly" />
        </Section>

        {/* ── Hot runner details (conditional) ── */}
        {form.runner === 'hot' && (
          <Section title="Hot runner details">
            <Select label="Nozzle type" value={hrData.nozzle_type} onChange={v => setHr('nozzle_type', v)}
              options={[{v:'open',l:'Open tip'},{v:'valve',l:'Valve gate'},{v:'other',l:'Other'}]}
              info="Open tips are simpler and cheaper; valve gates give a cleaner gate mark and better control" />
            <Field label="Controller model" value={hrData.controller} onChange={v => setHr('controller', v)}
              info="Brand and model of the hot runner temperature controller" />
            <Field label="Manifold temp (°C)" value={hrData.manifold_temp} onChange={v => setHr('manifold_temp', v)} type="number"
              info="Set temperature for the manifold — distributes melt to individual nozzles" />
            <div style={{ marginTop: '6px' }}>
              <div style={{ ...s.label, marginBottom: '6px' }}>Temperature zones</div>
              {hrData.zones.map((zone, i) => (
                <div key={i} style={{ display: 'flex', gap: '6px', alignItems: 'center', marginBottom: '6px' }}>
                  <input style={{ ...s.input, flex: 2 }} placeholder="Zone label" value={zone.label}
                    onChange={e => setHrZone(i, 'label', e.target.value)} />
                  <input type="number" style={{ ...s.input, width: '72px', flex: 'none' }} placeholder="°C" value={zone.temp}
                    onChange={e => setHrZone(i, 'temp', e.target.value)} />
                  <button style={s.removeBtn} onClick={() => removeHrZone(i)}>×</button>
                </div>
              ))}
              <button style={s.addSmallBtn} onClick={addHrZone}>+ Add zone</button>
            </div>
          </Section>
        )}

        {/* ── Shot weights ── */}
        <Section title="Shot weights">
          <Field label="Shot weight — all cavities + runner (g)" value={form.sw_g} onChange={v => set('sw_g', v)} type="number"
            info="Total material injected per cycle — includes all cavities plus the runner system" />
          <Field label="Part weight per cavity (g)" value={form.pw_g} onChange={v => set('pw_g', v)} type="number"
            info="Weight of one finished part, excluding runner material" />
          <Field label="Runner weight (g)" value={form.rw_g} onChange={v => set('rw_g', v)} type="number"
            info="Weight of the runner and sprue that is trimmed off or recycled after each cycle" />
        </Section>

        {/* ── Cooling ── */}
        <Section title="Cooling">
          <Field label="Cooling circuits" value={form.circuits} onChange={v => set('circuits', v)} type="number"
            info="Total number of independent cooling water channels in the mould" />
          <Field label="Water diameter (mm)" value={form.water_dia_mm} onChange={v => set('water_dia_mm', v)} type="number"
            info="Internal diameter of the cooling channels — affects flow rate and heat removal capacity" />
          <Field label="Target mould temp (°C)" value={form.target_mould_temp} onChange={v => set('target_mould_temp', v)} type="number"
            info="Recommended mould surface temperature during steady-state production" />
          <Select label="Cooling medium" value={form.cooling_medium} onChange={v => set('cooling_medium', v)}
            options={[{v:'',l:'— select —'},{v:'water',l:'Water'},{v:'pressurised-water',l:'Pressurised water'},{v:'oil',l:'Oil'},{v:'glycol-mix',l:'Glycol mix'}]}
            info="Fluid used to control mould temperature — oil or glycol mix needed when running above 100°C" />
          <Select label="Cooling layout" value={form.cooling_layout} onChange={v => set('cooling_layout', v)}
            options={[{v:'',l:'— select —'},{v:'series',l:'Series'},{v:'parallel',l:'Parallel'}]}
            info="How circuits connect — parallel gives uniform flow and lower pressure drop; series is simpler to plumb" />
          <Select label="Cooling type" value={form.cooling_type} onChange={v => set('cooling_type', v)}
            options={[{v:'',l:'— select —'},{v:'straight-drills',l:'Straight drills'},{v:'baffles',l:'Baffles'},{v:'bubblers',l:'Bubblers'},{v:'conformal',l:'Conformal'}]}
            info="Physical construction of the cooling system — conformal cooling follows the cavity shape for maximum heat transfer" />
        </Section>

        {/* ── Ejection ── */}
        <Section title="Ejection">
          <Select label="Ejector type" value={form.ej_type} onChange={v => set('ej_type', v)}
            options={EJ_TYPES}
            info="Mechanism used to push the finished part out of the mould after opening" />
          <Field label="Ejector count" value={form.ej_count} onChange={v => set('ej_count', v)} type="number"
            info="Number of ejector pins or elements in the ejection system" />
          <Field label="Ejector stroke (mm)" value={form.ej_stroke_mm} onChange={v => set('ej_stroke_mm', v)} type="number"
            info="How far the ejectors travel forward to push the part completely clear of the mould" />
          <Field label="Ejector pulses" value={form.ej_pulses} onChange={v => set('ej_pulses', v)} type="number"
            info="Number of forward-back movements to vibrate the part free — helpful with sticky or deep parts" />
          <Select label="Ejector coupling" value={form.ej_couple} onChange={v => set('ej_couple', v)}
            options={EJ_COUPLES}
            info="How the ejector plate connects to the machine ejector rod — mechanical coupling gives precise positional control" />
          <Select label="Ejection side" value={form.ej_side} onChange={v => set('ej_side', v)}
            options={[{v:'',l:'— select —'},{v:'standard',l:'Standard (moving half)'},{v:'reverse',l:'Reverse (stationary half)'},{v:'same-side',l:'Same side as injection'}]}
            info="Which mould half contains the ejectors — standard is the moving half; reverse ejection is needed for certain part geometries" />
          <Check label="Side actions" checked={form.side_actions} onChange={v => set('side_actions', v)}
            info="Mould has hydraulic or pneumatic slides that move perpendicular to the mould open direction to form undercuts" />
          <Check label="Lifters" checked={form.lifters} onChange={v => set('lifters', v)}
            info="Angled pins that move laterally as the mould opens to release internal undercuts without external actuation" />
        </Section>

        {/* ── Cooling zones ── */}
        <Section title="Cooling zones">
          {coolingZones.map((zone, i) => (
            <CoolingZoneEditor key={i} zone={zone}
              onSet={(k, v) => setZone(i, k, v)}
              onRemove={() => removeZone(i)}
            />
          ))}
          <button style={s.addSmallBtn} onClick={addZone}>+ Add cooling zone</button>
        </Section>

        {/* ── Cores & side actions ── */}
        <Section title="Cores & side actions">
          {cores.map((core, i) => (
            <CoreEditor key={i} core={core}
              onSet={(k, v) => setCore(i, k, v)}
              onAddWT={() => addWait(i)}
              onRemoveWT={wi => removeWait(i, wi)}
              onSetWT={(wi, k, v) => setWait(i, wi, k, v)}
              onRemove={() => removeCore(i)}
            />
          ))}
          <button style={s.addSmallBtn} onClick={addCore}>+ Add core / side action</button>
        </Section>

        {/* ── Special mechanisms ── */}
        <Section title="Special mechanisms">
          <MechRow label="Pneumatic ejector valve"
            checked={specMech.pneumatic_ejector}  notes={specMech.pneumatic_ejector_notes}
            onCheck={v => setSpec('pneumatic_ejector', v)}  onNotes={v => setSpec('pneumatic_ejector_notes', v)} />
          <MechRow label="Collapsible cores"
            checked={specMech.collapsible_cores}  notes={specMech.collapsible_cores_notes}
            onCheck={v => setSpec('collapsible_cores', v)}  onNotes={v => setSpec('collapsible_cores_notes', v)} />
          <MechRow label="Unscrewing"
            checked={specMech.unscrewing}         notes={specMech.unscrewing_notes}
            onCheck={v => setSpec('unscrewing', v)}         onNotes={v => setSpec('unscrewing_notes', v)} />
        </Section>

        {/* ── Mould info ── */}
        <Section title="Mould info">
          {/* Steel grades — multi-entry */}
          <div style={s.field}>
            <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: '4px' }}>
              Steel grades
              <Info text="Steel grade used for each mould component — different grades suit different production volumes and processed materials" />
            </label>
            {steelGrades.map((sg, i) => (
              <div key={i} style={{ display: 'flex', gap: '6px', alignItems: 'flex-start', marginBottom: '8px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <input
                    style={s.input}
                    placeholder="Component (e.g. Cavity, Core, Slides…)"
                    value={sg.description}
                    onChange={e => setSteelGrade(i, 'description', e.target.value)}
                  />
                  <select
                    style={s.input}
                    value={sg.grade}
                    onChange={e => setSteelGrade(i, 'grade', e.target.value)}>
                    {STEEL_GRADES.map(g => <option key={g.v} value={g.v}>{g.l}</option>)}
                  </select>
                  {sg.grade === 'other' && (
                    <input
                      style={s.input}
                      placeholder="Specify grade…"
                      value={sg.custom || ''}
                      onChange={e => setSteelGrade(i, 'custom', e.target.value)}
                    />
                  )}
                </div>
                <button style={{ ...s.removeBtn, marginTop: '6px' }} onClick={() => removeSteelGrade(i)}>×</button>
              </div>
            ))}
            <button style={s.addSmallBtn} onClick={addSteelGrade}>+ Add steel grade</button>
          </div>

          <Select label="Mould base supplier" value={form.mould_base} onChange={v => set('mould_base', v)}
            options={MOULD_BASES}
            info="Manufacturer of the standard mould base (plates, pillars, guide bushes)" />
          {form.mould_base === 'other' && (
            <Field label="Specify base supplier" value={form.mould_base_custom} onChange={v => set('mould_base_custom', v)}
              info="Custom mould base supplier name" />
          )}
          <Select label="Cavity surface treatment" value={form.surface_treatment} onChange={v => set('surface_treatment', v)}
            options={[{v:'',l:'— select —'},{v:'polished',l:'Polished'},{v:'textured',l:'Textured'},{v:'edm',l:'EDM'},{v:'sandblasted',l:'Sandblasted'}]}
            info="How the cavity surfaces are finished — directly affects part appearance and release properties" />
          <Field label="Toolmaker" value={form.toolmaker} onChange={v => set('toolmaker', v)}
            info="Company or person who manufactured this mould" />
          <Field label="Inspection interval (shots)" value={form.insp_int} onChange={v => set('insp_int', v)} type="number"
            info="How many shots between scheduled routine inspection checks" />
          <Field label="General notes" value={form.notes} onChange={v => set('notes', v)} multiline
            info="Any additional notes about this mould" />
        </Section>

        {/* ── Tool change times ── */}
        <Section title="Tool change times">
          <Field label="Mount time (min)" value={form.toolchange_mount_min} onChange={v => set('toolchange_mount_min', v)} type="number"
            info="Average time to mount this mould onto the machine and get it ready to run" />
          <Field label="Unmount time (min)" value={form.toolchange_unmount_min} onChange={v => set('toolchange_unmount_min', v)} type="number"
            info="Average time to safely remove this mould from the machine" />
          <Field label="Additional startup time (min)" value={form.additional_startup_min} onChange={v => set('additional_startup_min', v)} type="number"
            info="Extra time beyond the machine warmup needed to achieve stable process with this mould — typical for hot runner moulds or complex temperature-sensitive tools" />
        </Section>

        {/* ── Special features ── */}
        <Section title="Special features">
          <Select label="Parting line" value={form.parting_line} onChange={v => set('parting_line', v)}
            options={[{v:'',l:'— select —'},{v:'flat',l:'Flat'},{v:'angled',l:'Angled'},{v:'stepped',l:'Stepped'}]}
            info="Geometry of the split line where the two mould halves meet — affects flash risk and part complexity" />
          <Field label="Vent depth (mm)" value={form.vent_depth_mm} onChange={v => set('vent_depth_mm', v)} type="number"
            info="Depth of gas venting channels — too shallow clogs; too deep causes visible flash on the part" />
          <Field label="Vent location notes" value={form.vent_notes} onChange={v => set('vent_notes', v)} multiline
            info="Location and details of venting points to help operators identify and clean them" />
          <Check label="In-mould labelling" checked={form.in_mould_label} onChange={v => set('in_mould_label', v)}
            info="Pre-printed labels are placed in the mould and fused to the part surface during injection" />
          <Check label="Insert moulding" checked={form.insert_moulding} onChange={v => set('insert_moulding', v)}
            info="Metal or other inserts are loaded into the mould before injection and become permanently embedded in the part" />
          {form.insert_moulding && (
            <Field label="Insert type" value={form.insert_type} onChange={v => set('insert_type', v)}
              info="Describe the insert (e.g. brass threaded insert, steel pin, PCB)" />
          )}
          <Check label="Mould breathing" checked={form.mould_breathing} onChange={v => set('mould_breathing', v)}
            info="Mould is intentionally allowed to open a small amount during injection to vent trapped gas (also called flash-free venting)" />
          {form.mould_breathing && (
            <Field label="Breathing distance (mm)" value={form.mould_breathing_mm} onChange={v => set('mould_breathing_mm', v)} type="number"
              info="How far the mould opens during the breathing phase" />
          )}
        </Section>

        {/* ── Mould notes ── */}
        <Section title="Mould notes (shown prominently on detail page)">
          <Field
            label="Known issues, quirks, or important reminders for setters and operators"
            value={form.mould_notes}
            onChange={v => set('mould_notes', v)}
            multiline
            info="This note appears at the top of the mould detail page — use it for anything a setter must know before running this mould" />
        </Section>

        {/* ── Shot limit, refurbishment and service (director only; 7 Oct 2026) ── */}
        {isDirector && (
          <Section title="Shot limit, refurbishment and service">
            <Select label="The shot limit is" value={form.shot_limit_kind} onChange={v => set('shot_limit_kind', v)}
              options={[{ v: 'warranty', l: 'A warranty' }, { v: 'shot_life', l: 'A shot life' }]}
              info="A warranty: everything is included up to the limit, then you agree with the customer what comes next (a paid extension, a new mould, a refurbishment with a limited warranty…). A shot life: after it the customer must buy a new mould. The board's warnings use the words that fit." />
            <Field label={form.shot_limit_kind === 'shot_life' ? 'Shot life (shots)' : 'Warranty (shots)'}
              value={form.shot_life} onChange={v => set('shot_life', v)} type="number"
              info="Counted over the tool from its start, or from its last new warranty / new mould in the log. Services and refurbishments do not reset it." />
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
              <div style={{ flex: 1 }}>
                <Field label="Shot count (correct it)" value={form.shots} onChange={v => set('shots', v)} type="number"
                  info="The tools have no counters, so the app counts from the production it records (from 13 Jul 2026, good parts only) — see the mould's History page for the count now. Put the real count here when you know it, with the day it was true; the app counts on from there. Every correction is kept in the mould's history." />
              </div>
              <div style={{ flex: 1 }}>
                <Field label="…as of" value={form.shots_counted_on} onChange={v => set('shots_counted_on', v)} type="date"
                  info="The day the count was true (runs that ended that day are in it). Left empty: an estimate for the time before 13 Jul 2026." />
              </div>
            </div>
            <Field label="Refurbish every (shots)" value={form.refurb_int} onChange={v => set('refurb_int', v)} type="number"
              info="The big service: worn parts replaced, improvements made. Counted from the last refurbishment in the log." />
            <Field label="Service every (shots)" value={form.service_every_shots} onChange={v => set('service_every_shots', v)} type="number"
              info="Take apart, clean, oil, grease. Counted from the last service or refurbishment in the log. If a time is set too, whichever comes first." />
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
              <div style={{ flex: 1 }}>
                <Field label="…or every" value={form.service_every_n} onChange={v => set('service_every_n', v)} type="number"
                  info="Service by time: every so many weeks or months since the last service. If shots are set too, whichever comes first." />
              </div>
              <div style={{ flex: 1 }}>
                <Select label="weeks or months" value={form.service_every_unit} onChange={v => set('service_every_unit', v)}
                  options={[{ v: '', l: '— none —' }, { v: 'weeks', l: 'weeks' }, { v: 'months', l: 'months' }]} />
              </div>
            </div>
          </Section>
        )}

        {/* ── Financial (director only) ── */}
        {isDirector && (
          <Section title="Financial">
            <Field label="Tool cost (€)" value={form.tool_cost} onChange={v => set('tool_cost', v)} type="number"
              info="Original cost of the mould — used to calculate per-part tooling amortisation" />
          </Section>
        )}

        {/* ── Custom fields (director only) ── */}
        {isDirector && (
          <Section title="Custom fields" span>
            {customFields.map((cf, i) => (
              <div key={i} style={{ display: 'flex', gap: '6px', alignItems: 'center', marginBottom: '8px' }}>
                <input style={{ ...s.input, flex: 1 }} placeholder="Label" value={cf.label}
                  onChange={e => setCustomField(i, 'label', e.target.value)} />
                <input style={{ ...s.input, flex: 2 }} placeholder="Value" value={cf.value}
                  onChange={e => setCustomField(i, 'value', e.target.value)} />
                <button style={s.removeBtn} onClick={() => removeCustomField(i)}>×</button>
              </div>
            ))}
            <button style={s.addSmallBtn} onClick={addCustomField}>+ Add custom field</button>
          </Section>
        )}

      </div>

      <div style={s.footer}>
        {onCancel && <button style={s.cancelBtn} onClick={onCancel}>Cancel</button>}
        <button style={{ ...s.saveBtn, opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={save}>
          {saving ? 'Saving...' : isNew ? 'Add Mould' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}

// ── SUB-COMPONENTS ────────────────────────────────────────────

function Info({ text }) {
  const [show, setShow] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}>
      <i className="fa-solid fa-circle-info" style={{ fontSize: '11px', color: '#4b5563', cursor: 'help' }} />
      {show && (
        <span style={{
          position: 'absolute', bottom: 'calc(100% + 4px)', left: '50%', transform: 'translateX(-50%)',
          background: '#1e2329', border: '1px solid #374151', borderRadius: '6px',
          padding: '7px 10px', fontSize: '11px', color: '#d1d5db', lineHeight: '1.5',
          width: '220px', zIndex: 200,
          boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
          pointerEvents: 'none', whiteSpace: 'normal',
        }}>
          {text}
        </span>
      )}
    </span>
  );
}

function CoreEditor({ core, onSet, onAddWT, onRemoveWT, onSetWT, onRemove }) {
  return (
    <div style={{ background: '#0f1117', border: '1px solid #2a3040', borderRadius: '8px', padding: '12px', marginBottom: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '10px' }}>
        <input style={{ ...s.input, flex: 1, fontWeight: '600' }} placeholder="Core / action name"
          value={core.name} onChange={e => onSet('name', e.target.value)} />
        <button style={s.removeBtn} onClick={onRemove}>×</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '8px', marginBottom: '10px' }}>
        <div>
          <div style={s.label}>Actuator</div>
          <select style={s.input} value={core.actuator_type} onChange={e => onSet('actuator_type', e.target.value)}>
            <option value="hydraulic">Hydraulic</option>
            <option value="pneumatic">Pneumatic</option>
          </select>
        </div>
        <div>
          <div style={s.label}>Pressure (bar)</div>
          <input type="number" style={s.input} value={core.pressure_bar} onChange={e => onSet('pressure_bar', e.target.value)} />
        </div>
        <div>
          <div style={s.label}>Speed (mm/s)</div>
          <input type="number" style={s.input} value={core.speed_mm_s} onChange={e => onSet('speed_mm_s', e.target.value)} />
        </div>
        <div>
          <div style={s.label}>Stroke (mm)</div>
          <input type="number" style={s.input} value={core.stroke_mm} onChange={e => onSet('stroke_mm', e.target.value)} />
        </div>
        <div>
          <div style={s.label}>Actuation time (s)</div>
          <input type="number" style={s.input} value={core.actuating_time_s} onChange={e => onSet('actuating_time_s', e.target.value)} />
        </div>
      </div>
      <div style={{ ...s.label, marginBottom: '4px' }}>Waiting times</div>
      {(core.waiting_times || []).map((wt, i) => (
        <div key={i} style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '6px' }}>
          <select style={{ ...s.input, flex: 2 }} value={wt.trigger} onChange={e => onSetWT(i, 'trigger', e.target.value)}>
            {CORE_TRIGGERS.map(t => <option key={t.v} value={t.v}>{t.l}</option>)}
          </select>
          <input type="number" style={{ ...s.input, width: '68px', flex: 'none' }} placeholder="s"
            value={wt.time_s} onChange={e => onSetWT(i, 'time_s', e.target.value)} />
          <span style={{ fontSize: '11px', color: '#6b7280' }}>s</span>
          <button style={s.removeBtn} onClick={() => onRemoveWT(i)}>×</button>
        </div>
      ))}
      <button style={{ ...s.addSmallBtn, marginTop: '8px' }} onClick={onAddWT}>+ Add wait</button>
    </div>
  );
}

function CoolingZoneEditor({ zone, onSet, onRemove }) {
  return (
    <div style={{ background: '#0f1117', border: '1px solid #2a3040', borderRadius: '8px', padding: '12px', marginBottom: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '10px' }}>
        <select style={{ ...s.input, flex: 2 }} value={zone.location} onChange={e => onSet('location', e.target.value)}>
          <option value="injection-half">Injection half</option>
          <option value="ejection-half">Ejection half</option>
          <option value="core">Core</option>
          <option value="slider">Slider</option>
          <option value="stripper">Stripper plate</option>
        </select>
        <button style={s.removeBtn} onClick={onRemove}>×</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '8px' }}>
        <div>
          <div style={s.label}>Circuit diameter (mm)</div>
          <input type="number" style={s.input} value={zone.diameter_mm} onChange={e => onSet('diameter_mm', e.target.value)} />
        </div>
        <div>
          <div style={s.label}>Circuit length (mm)</div>
          <input type="number" style={s.input} value={zone.length_mm} onChange={e => onSet('length_mm', e.target.value)} />
        </div>
        <div>
          <div style={s.label}>Circuits in zone</div>
          <input type="number" style={s.input} value={zone.circuits} onChange={e => onSet('circuits', e.target.value)} />
        </div>
      </div>
    </div>
  );
}

function MechRow({ label, checked, notes, onCheck, onNotes }) {
  return (
    <div style={{ marginBottom: '10px' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#f0f2f5', marginBottom: '4px' }}>
        <input type="checkbox" checked={checked} onChange={e => onCheck(e.target.checked)} />
        {label}
      </label>
      {checked && (
        <textarea
          style={{ ...s.input, width: '100%', minHeight: '56px', resize: 'vertical', boxSizing: 'border-box', marginTop: '2px' }}
          placeholder="Notes..."
          value={notes}
          onChange={e => onNotes(e.target.value)}
        />
      )}
    </div>
  );
}

function Section({ title, children, span, cols }) {
  const colStyle = span ? { gridColumn: '1 / -1' } : cols ? { gridColumn: `span ${cols}` } : {};
  return (
    <div style={{ ...s.section, ...colStyle }}>
      <div style={s.sectionTitle}>{title}</div>
      {children}
    </div>
  );
}

function Field({ label, value, onChange, type = 'text', multiline, info }) {
  return (
    <div style={s.field}>
      <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: '4px' }}>
        {label}
        {info && <Info text={info} />}
      </label>
      {multiline
        ? <textarea style={{ ...s.input, minHeight: '80px', resize: 'vertical' }} value={value} onChange={e => onChange(e.target.value)} />
        : <input type={type} style={s.input} value={value} onChange={e => onChange(e.target.value)} />
      }
    </div>
  );
}

function Select({ label, value, onChange, options, info }) {
  return (
    <div style={s.field}>
      <label style={{ ...s.label, display: 'flex', alignItems: 'center', gap: '4px' }}>
        {label}
        {info && <Info text={info} />}
      </label>
      <select style={s.input} value={value} onChange={e => onChange(e.target.value)}>
        {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

function Check({ label, checked, onChange, info }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', cursor: 'pointer', fontSize: '13px', color: '#f0f2f5' }}>
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
      {label}
      {info && <Info text={info} />}
    </label>
  );
}

const s = {
  fullGrid:    { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' },
  compactGrid: { display: 'flex', flexDirection: 'column', gap: '0' },
  section:     { background: '#1e2329', border: '1px solid #2a3040', borderRadius: '10px', padding: '16px', marginBottom: '12px' },
  sectionTitle:{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#14b8a6', marginBottom: '12px', paddingBottom: '6px', borderBottom: '1px solid #2a3040' },
  field:       { display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '10px' },
  label:       { fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#6b7280' },
  input:       { background: '#0f1117', border: '1px solid #2a3040', borderRadius: '6px', color: '#f0f2f5', padding: '8px 10px', fontSize: '13px', fontFamily: 'system-ui, sans-serif' },
  footer:      { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #2a3040' },
  cancelBtn:   { background: '#1e2329', border: '1px solid #2a3040', color: '#9ca3af', borderRadius: '8px', padding: '10px 16px', fontSize: '13px', cursor: 'pointer' },
  saveBtn:     { background: '#14b8a6', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 24px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  error:       { background: '#7f1d1d', color: '#fca5a5', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', marginBottom: '12px' },
  addSmallBtn: { background: '#1e2329', border: '1px solid #2a3040', color: '#9ca3af', borderRadius: '6px', padding: '5px 10px', fontSize: '11px', cursor: 'pointer' },
  removeBtn:   { background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '20px', lineHeight: 1, padding: '0 4px' },
};
